import { API_TOKEN_ENDPOINT, OAUTH_REDIRECT_URI } from "../environmentVariables";

export function getUserToken(authorizationCode) {
  const url = API_TOKEN_ENDPOINT;
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      authorizationCode: authorizationCode,
      redirectUrl: OAUTH_REDIRECT_URI,
      //bypass mfa until token expiration if user selected remember this device
      device_token: localStorage.getItem("device_token"),
    }),
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error("Error siging in with OAuth");
    }
  });
}
